import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { IMAGES } from '../data';
import { Reveal } from './Reveal';
export function Tonality() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);
  return <section ref={ref} className="relative w-full overflow-hidden" data-id="element-310" data-mp="4d2hy09vnq43">
      <motion.img style={{
      y
    }} src={IMAGES.peopleLaughing} alt="Vänner och familj som skrattar runt ett middagsbord i kvällsljus" className="absolute inset-0 h-[130%] w-full object-cover" data-id="element-311" data-mp="4a7xi8qv65ao" />
      <div className="absolute inset-0 bg-bourgogne/80" data-id="element-312" data-mp="3mipa1g4cpgpe" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 py-32 text-center text-warm md:py-48 md:px-10" data-id="element-313" data-mp="3mka4z6ukv1ns">
        <Reveal data-id="element-314" data-mp="1pnt30czdx1jm">
          <p className="text-[12px] uppercase tracking-wide3 text-warm/60" data-id="element-315" data-mp="1kqswy22jbysi">Tonalitet</p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-316" data-mp="7i159am2l7si">
          <p className="mt-8 font-display text-2xl font-light leading-snug text-warm/50 line-through decoration-1 md:text-3xl" data-id="element-317" data-mp="7gpzx6cz7rza">
            Sveriges största cateringportal.
          </p>
        </Reveal>
        <Reveal delay={0.2} data-id="element-318" data-mp="3tq0yt2o9ca4s">
          <h2 className="mt-6 font-display text-4xl font-light leading-tight md:text-6xl" data-id="element-319" data-mp="3tqu2tvvu0lj8">
            Smålands bästa smaker.
            <br data-id="element-320" data-mp="q8af96o3m3ur" />
            Noggrant utvalda.
          </h2>
        </Reveal>
        <Reveal delay={0.3} data-id="element-321" data-mp="qadf0if1zbco">
          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-warm/80" data-id="element-322" data-mp="v73vv7yomaz5">
            Till människor som uppskattar riktigt bra mat.
          </p>
        </Reveal>
        <Reveal delay={0.4} data-id="element-323" data-mp="ggmv7qtvfp3b">
          <div className="mt-12" data-id="element-324" data-mp="lh0scdtxpemk">
            <a href="/utbud" className="inline-block rounded-full border border-warm/50 px-8 py-3 text-sm uppercase tracking-wide2 text-warm transition-colors hover:bg-warm hover:text-brun" data-id="element-325" data-mp="lg96huq52v9h">
              Se utbud
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}